import React from 'react';
import VenuePreview from './VenuePreview'

export default class CustomOption extends React.Component {
  render() {
    const { innerRef, innerProps, value, label, data } = this.props

    return (
      <div
        {...innerProps}
        ref={innerRef}
      >
        <VenuePreview data={data} />
      </div>
    )
  }
}
